import * as types from "./types";

export default {
  [types.CONSULTANTS_SEARCH_RESULT]: (state) => {
    return state.searchResult;
  },
  [types.DNA_HISTORICAL_SEARCH_RESULT]: (state) => {
    return state.searchResultDnaHistorical;
  },
  [types.IMPORT_SEARCH_RESULT]: (state) => {
    return state.searchResultImports;
  },
  [types.IMPORT_HISTORY_SEARCH_RESULT]: (state) => {
    return state.searchResultImportHistory;
  },
  [types.DETAILS_GENERAL_INFORMATION]: (state) => {
    return state.details.generalInformation;
  },
  [types.DETAILS_COMPANY_DATA]: (state) => {
    return state.details.companyData;
  },
  [types.DETAILS_NETWORK_DATA]: (state) => {
    return state.details.networkData;
  },
  [types.DIRECT_TEAM]: (state) => {
    return state.details.directTeam;
  },
  [types.NEW_CONSULTANT_SIDEBAR]: (state) => {
    return state.newConsultantSidebar;
  },
  [types.NEW_EMPLOYEE_SIDEBAR]: (state) => {
    return state.newEmployeeSidebar;
  },
  [types.TRANSFERRED_CONSULTANTS]: (state) => {
    return state.transferredConsultants;
  },
  [types.TRANSFERABLE_CONSULTANTS]: (state) => {
    return state.transferableConsultants;
  },
  [types.CHANGE_CONSULTANT_ROLE_SIDEBAR]: (state) => {
    return state.changeConsultantRoleSidebar;
  },
  [types.CHANGE_PHYSICAL_FRANCHISE_SIDEBAR]: (state) => {
    return state.changePhysicalFranchiseSidebar;
  },
  [types.AFFILIATION_TYPES]: (state) => {
    return state.affiliationTypes;
  },
  [types.IMPORT_EAD_SIDEBAR]: (state) => {
    return state.importEadSidebar;
  },
  [types.PENDING_PROMOTION_STEPS]: (state) => {
    return state.pendingPromotionSteps;
  },
  [types.DETAILS_INDICATORS_SUMMARY]: (state) => {
    return state.indicatorsSummary;
  },
  [types.DETAILS_APPOINTMENT_CLOSURE_RATES]: (state) => {
    return state.appointmentClosureRates;
  },
  [types.DETAILS_QUALITATIVE_HIGHLIGHTS]: (state) => {
    return state.qualitativeHighlights;
  },
  [types.PENDING_PROMOTION_STEPS]: state => {
    return state.pendingPromotionSteps
  },
  [types.CONSULTANT_CERTIFICATE_SIDEBAR]: state => {
    return state.consultantCertificateSidebar
  },
  [types.CONSULTANT_CERTIFICATE_TYPES]: state => {
    return state.certificateTypes
  },
  [types.CONSULTANT_TERMINATION_REASONS]: state => {
    return state.consultantTerminationReasons
  },
  [types.PROMOTION_CONTRACT_RULES]: (state) => {
    return state.promotionContractRules;
  },
  [types.ROLE_PROMOTION_SIDEBAR]: (state) => {
    return state.rolePromotionSidebar;
  },
  [types.ROLE_PROMOTION_SEARCH_RESULT]: (state) => {
    return state.rolePromotionSearchResult;
  },
  [types.ROLE_PROMOTION_STATUS_TYPES]: (state) => {
    return state.rolePromotionStatusTypes;
  },
  [types.PNS_PENDING_ONBOARDING]: (state) => {
    return state.pns_pending_onboarding;
  },
}
